/* Header: desktop mega-menu (hover + focus + click, keyboard/Escape) and the
   mobile menu drawer. Accessible: aria-expanded on triggers, focus trap-lite,
   Escape closes. */
(function () {
  /* ---------- Desktop mega-menu ---------- */
  var items = document.querySelectorAll('[data-nav-item]');
  var openItem = null;
  function close(item) {
    if (!item) return;
    item.classList.remove('is-open');
    var t = item.querySelector('[data-nav-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
  }
  function open(item) {
    if (openItem && openItem !== item) close(openItem);
    item.classList.add('is-open');
    var t = item.querySelector('[data-nav-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
    openItem = item;
  }
  items.forEach(function (item) {
    var trigger = item.querySelector('[data-nav-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      item.classList.contains('is-open') ? close(item) : open(item);
    });
    item.addEventListener('mouseenter', function () { open(item); });
    item.addEventListener('mouseleave', function () { close(item); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close(item);
    });
  });
  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) close(openItem);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) {
      var t = openItem.querySelector('[data-nav-trigger]');
      close(openItem);
      if (t) t.focus();
    }
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = document.getElementById('MenuDrawer');
  if (!drawer) return;
  var openers = document.querySelectorAll('[data-drawer-open]');
  var lastFocus = null;
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    var c = drawer.querySelector('[data-drawer-close]');
    if (c) c.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  openers.forEach(function (o) { o.addEventListener('click', openDrawer); });
  drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
})();

/* ---------- Cart badge state ----------
   Toggle `is-empty` on the count bubble so the pulsing halo (CSS) shows only
   when there is something to check out. A MutationObserver keeps it correct no
   matter which script (drawer, quick-add, product, cart) writes the count, and
   it lives in its own IIFE so the mobile-drawer early return above can't skip
   it. */
(function () {
  var badges = document.querySelectorAll('[data-cart-count]');
  if (!badges.length) return;
  function sync(el) {
    var n = parseInt(el.textContent, 10);
    el.classList.toggle('is-empty', !(n > 0));
  }
  badges.forEach(function (el) {
    sync(el);
    new MutationObserver(function () { sync(el); }).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();
